import type { FC } from "react";

import { useLowCreditsBanner } from "../../hooks/useLowCreditsBanner";
import type { LowQuotaBannerDestinationType } from "../../types";
import { LowCreditsBanner } from "../LowCreditsBanner/LowCreditsBanner";

import { LowCreditsBannerWrapper, StyledSelectionDropdownQuotaFooterContainer } from "./styles";

interface ISelectionDropdownQuotaFooterProps {
    totalQuota: number;
    remainingQuota: number;
    pricePerRecord?: number;
    minOptionValue?: number;
    maxOptionValue?: number;
    destinationType?: LowQuotaBannerDestinationType;
}

export const SelectionDropdownQuotaFooter: FC<ISelectionDropdownQuotaFooterProps> = ({
    totalQuota,
    remainingQuota,
    pricePerRecord,
    minOptionValue,
    maxOptionValue,
    destinationType,
}) => {
    const { isVisible, bannerConfigs } = useLowCreditsBanner({
        totalQuota,
        remainingQuota,
        pricePerRecord,
        minOptionValue,
        maxOptionValue,
        type: destinationType,
    });

    return (
        <StyledSelectionDropdownQuotaFooterContainer>
            {isVisible ? (
                <LowCreditsBannerWrapper>
                    <LowCreditsBanner
                        {...bannerConfigs}
                        isStacked
                    />
                </LowCreditsBannerWrapper>
            ) : null}
        </StyledSelectionDropdownQuotaFooterContainer>
    );
};
